/* eslint no-console: 0 */
const shouldLog = () => {
  const { NODE_ENV, isClient } = process.env
  return NODE_ENV === 'production' ? !isClient : NODE_ENV !== 'test'
}

const printLogError = (...args) => {
  shouldLog() && console.log(...args)
}

const logger = {
  info (...args) {
    printLogError(...args)
  },
  warn (...args) {
    printLogError(...args)
  },
  error (...args) {
    printLogError(...args)
  }
}

export default logger
